/** What the policy needs of a `<video>`: only the ability to stop it. */
export interface Playable {
  pause(): void;
}

export interface SinglePlayer {
  /** `player` is starting: pause whichever other one was playing. */
  claim(player: Playable): void;
  /** The one allowed to play, if any. */
  readonly current: Playable | null;
  /** `player` is going away; forget it if it was the one playing. */
  release(player: Playable): void;
}

/**
 * One playing video on screen (A2 plays only the workout plate and the deck
 * card). Starting one pauses the other — it never reloads it: `pause()` keeps
 * the element and its buffered data, where re-assigning `src` would run the
 * load algorithm again (T-155).
 */
export function createSinglePlayer(): SinglePlayer {
  let current: Playable | null = null;
  return {
    claim(player) {
      if (current !== null && current !== player) {
        current.pause();
      }
      current = player;
    },
    release(player) {
      if (current === player) {
        current = null;
      }
    },
    get current() {
      return current;
    },
  };
}
